import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { IconButton } from '@/shared/components/ui/common/IconButton';
import { IconWithBackground } from '@/shared/components/ui/common/IconWithBackground';
import { FeatherFile } from '@subframe/core';
import { FeatherX } from '@subframe/core';
type ArquivoAnexadoProps = {
  fileName: string;
  fileSize: string;
  onRemove: () => void;
};
export function ArquivoAnexado(t0) {
  const $ = _c(14);
  const {
    fileName,
    fileSize,
    onRemove
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconWithBackground size="large" icon={<FeatherFile />} square={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== fileName) {
    t2 = <span className="text-body-bold font-body-bold text-default-font">{fileName}</span>;
    $[1] = fileName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== fileSize) {
    t3 = <div className="flex items-center gap-3"><span className="text-caption font-caption text-subtext-color">{fileSize}</span></div>;
    $[3] = fileSize;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex shrink-0 grow basis-0 flex-col items-start gap-1">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherX />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onRemove) {
    t6 = <IconButton icon={t5} onClick={onRemove} />;
    $[9] = onRemove;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="bg-default-background flex w-full flex-col items-start gap-4 rounded-[16px] border border-solid border-neutral-200 px-4 py-4"><div className="flex w-full items-center gap-3">{t1}{t4}{t6}</div></div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}